import { Entity } from '@backstage/catalog-model';
import { isSecurityInsightsAvailable } from '@roadiehq/backstage-plugin-security-insights';
import { PLATT_GH_SECURITY_INSIGHTS_ANNOTATION } from './platt-annotations';

export const isGitHubSecurityInsightsAvailable = (entity: Entity): boolean => {
  return Boolean(entity?.metadata?.annotations?.[PLATT_GH_SECURITY_INSIGHTS_ANNOTATION]
    && isSecurityInsightsAvailable(entity)
  );
};
